import { motion } from 'framer-motion';
import { Clock, Monitor, Smartphone } from 'lucide-react';

const problems = [
  {
    icon: Monitor,
    title: 'Overwhelming Video Content',
    description: 'Students struggle to manage hours of video lectures effectively.',
  },
  {
    icon: Clock,
    title: 'Limited Learning Time',
    description: 'Traditional note-taking is time-consuming and inefficient.',
  },
  {
    icon: Smartphone,
    title: 'Screen Time Concerns',
    description: 'Extended video watching leads to digital fatigue.',
  },
];

export function AboutWhy() {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-3xl font-bold text-gray-900">Why StudySnap</h2>
          <p className="mt-4 text-lg text-gray-600">
            We're solving real problems in modern education
          </p>
        </motion.div>
        <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {problems.map((problem, index) => (
            <motion.div
              key={problem.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="rounded-2xl border border-gray-200 bg-white p-8 shadow-sm"
            >
              <div className="inline-flex rounded-lg bg-indigo-50 p-3">
                <problem.icon className="h-6 w-6 text-indigo-500" />
              </div>
              <h3 className="mt-6 text-xl font-semibold text-gray-900">
                {problem.title}
              </h3>
              <p className="mt-2 text-gray-600">{problem.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}